import React, { useState, useEffect } from "react";
import Select from "components/elements/Select";
import Toggle from "components/elements/Toggle";
import IconButton from "components/elements/IconButton";
import { useRef } from "react";
import LargeModal from "components/elements/LargeModal";
import DateInput from "components/elements/DateInput";
import SubscriptionPreview from "./SubscriptionPreview";
import { useOutletContext } from "react-router-dom";
//import { MultiSelect } from "primereact/multiselect";
//import { MultiSelect } from "primereact/multiselect";
import MultiSelectDropdown from "./MultiSelectDropdown"; // Import your common dropdown
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import {
  CLIENT_BROADCASTER,
CONTENT_TYPES,
  LS_CLONE_SUB_KEY,
  USER_CLIENT_MANAGER,
  USER_SUPERADMIN,
} from "core/Constants";
import _ from "lodash";
import dataProvider from "core/DataProvider";
import { USER_BUSINESS_ADMIN } from "core/Constants";
import { toast } from "react-hot-toast";
import utility from "core/Utils";

const selectItems = ["Category", "Brand", "Caption", "Edit", "Channels"];

let edits = [];
for (let i = 1; i < 121; i++) {
  i = i.toString();
  edits.push({ value: i, label: i });
}

const NewSubscription = () => {
  // toggle states
  const [allSelectedState, setAllSelectedState] = useState(
    new Array(selectItems.length).fill(true)
  );
  // form data
  const [group, setGroup] = useState("");
  const [groups, setGroups] = useState([]);
  const [client, setClient] = useState("");
  const [clients, setClients] = useState([]);
  const [contentType, setContentType] = useState("");
  const [advertiser, setAdvertiser] = useState("");
  const [advertisers, setAdvertisers] = useState([]);
  const [periodFrom, setPeriodFrom] = useState("");
  const [periodTo, setPeriodTo] = useState("");
  const [approvingAuthority, setApprovingAuthority] = useState(null);
  const [approvingAuthorities, setApprovingAuthorities] = useState([]);

  // list data
  const [groupDetails, setGroupDetails] = useState(null);
  const [categoryListing, setCategoryListing] = useState([]);
  const [brandListing, setBrandListing] = useState([]);
  const [captionListing, setCaptionListing] = useState([]);
  const [editListing, setEditListing] = useState([...edits]);
  const [channelListing, setChannelListing] = useState([]);
  const [selectedChannels, setSelectedChannels] = useState([]);
  const [contentTypeOptions, setContentTypeOptions] = useState([]);
const [is_ica, setIsIca] = useState(false);
  // list searches
  const [allSearches, setAllSearches] = useState({
    categories: "",
    brands: "",
    captions: "",
    edits: "",
    channels: "",
  });

  const [language, setLanguage] = useState([]);
  const [languages, setLanguages] = useState([]);

  const [genre, setGenre] = useState([]);
  const [genres, setGenres] = useState([]);

  const [network, setNetwork] = useState([]);
  const [networks, setNetworks] = useState([]);

  const [showInputModal, setShowInputModal] = useState(false);
  const [channelInput, setChannelInput] = useState("");
  const [matchedList, setMatchedList] = useState([]);
  const [totalInputCount, setTotalInputCount] = useState(0);
  const [showPreview, setShowPreview] = useState(false);

  const [groupSubscriptionFrom, setGroupSubscriptionFrom] = useState("");
  const [groupSubscriptionTo, setGroupSubscriptionTo] = useState("");

  const selRefs = [
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
  ];
  const token = useOutletContext();

  const permissionCheck = key => {
    let show = false;

    if (key === "show_advertiser_select") {
      if (!token.client_id) {
        show = true;
      } else if (token.client_id && token.client_type !== CLIENT_BROADCASTER) {
        show = true;
      }
    }

    if (key === "disable_advertiser_select") {
      if (
        client &&
        groupDetails &&
        groupDetails.client_type === CLIENT_BROADCASTER
      ) {
        show = true;
      }
    }

    if (key === "enable_channel_toggle") {
      let isSelectionsMatched = false;
      if (token.client_id) {
        if (
          group &&
          client &&
          periodFrom &&
          periodTo &&
          contentType &&
          approvingAuthority
        ) {
          isSelectionsMatched = true;
        }
      } else {
        if (group && client && periodFrom && periodTo && contentType) {
          isSelectionsMatched = true;
        }
      }

      if (isSelectionsMatched) {
        if (
          groupDetails &&
          groupDetails &&
          groupDetails.client_type === CLIENT_BROADCASTER
        ) {
          show = true;
        } else if (advertiser) {
          show = true;
        }
      }
    }

    if (key === "enable_toggles") {
      if (token.client_id) {
        if (
          group &&
          client &&
          periodFrom &&
          periodTo &&
          contentType &&
          advertiser &&
          approvingAuthority
        ) {
          show = true;
        }
      } else if (
        group &&
        client &&
        periodFrom &&
        periodTo &&
        contentType &&
        advertiser
      ) {
        show = true;
      }
    }

    return show;
  };

  const handleAllSelected = (listIndex, val) => {
    let newState = [...allSelectedState];
    newState[listIndex] = val === "All" ? true : false;
    setAllSelectedState(newState);

    if (val !== "All") {
      setTimeout(() => {
        try {
          selRefs[listIndex].current.scrollIntoView({
            block: "start",
            behavior: "smooth",
          });
        } catch (error) {
          console.warn(
            `failed to scroll into view for ${selectItems[listIndex]}`
          );
        }
      }, 200);
    }

    if (listIndex === 0 && val !== "All") {
      getBrandCategories();
    }
    if (listIndex === 1 && val !== "All") {
      getBrands();
    }
    if (listIndex === 2 && val !== "All") {
      getDescriptors();
    }
  };

  const findChannels = () => {
    let processed = [];
    let matched = [];
    let matchedDataLines = [];
    let tcount = 0;

    let lines = channelInput.split("\n");

    for (let i = 0; i < lines.length; i++) {
      if (lines[i] === "") {
        continue;
      }

      if (processed.includes(lines[i].toLowerCase())) {
        continue;
      }

      let o = {
        raw: lines[i],
        matched: null,
      };

      for (let j = 0; j < channelListing.length; j++) {
        if (channelListing[j].label.toLowerCase() === lines[i].toLowerCase()) {
          o.matched = channelListing[j];
          break;
        }
      }

      if (o.matched) {
        matched.push(o);
      } else {
        matchedDataLines.push(o);
      }
      tcount++;
      processed.push(lines[i].toLowerCase());
    }

    matchedDataLines = [...matchedDataLines, ...matched];
    setMatchedList(matchedDataLines);
    setTotalInputCount(tcount);
  };

  const handleNotFoundSelect = (index, val) => {
    let alreadySelected = false;
    let alreadySelectedLabel = "";

    for (let i = 0; i < matchedList.length; i++) {
      if (
        matchedList[i].matched &&
        matchedList[i].matched.value === val.value
      ) {
        alreadySelected = true;
        alreadySelectedLabel = matchedList[i].matched.label;
        break;
      } else {
      }
    }

    if (alreadySelected) {
      alert(`${val.label} is already selected in other option`);
      return;
    } else {
      let newList = [...matchedList];
      newList[index].matched = val;
      setMatchedList(newList);
    }
  };

  const addMatchedListToSelected = () => {
    let toAdd = [];
    let existingValues = selectedChannels.map(x => x.value);
    let matches = matchedList.filter(x => x.matched).map(x => x.matched);

    for (let i = 0; i < matches.length; i++) {
      if (!existingValues.includes(matches[i].value)) {
        toAdd.push(matches[i]);
      }
    }

    setSelectedChannels([...toAdd, ...selectedChannels]);
    setShowInputModal(false);
  };

  const getBrandCategories = async () => {
    let advID = advertiser.value;
    let ctID = contentType.value;

    if (!advID) {
      return;
    }

    let d = await dataProvider.network.post(`masters/brand-category`, {
      content_type: parseInt(ctID),
      advertisers: [advID],
    });
    if (d) {
      const cloneSub = JSON.parse(localStorage.getItem(LS_CLONE_SUB_KEY));
      if (cloneSub) {
        for (let i = 0; i < d.length; i++) {
          let isSelected = false;
          for (let j = 0; j < cloneSub.categoryList.length; j++) {
            if (
              parseInt(cloneSub.categoryList[j].id) ===
              parseInt(d[i].brandcategorycode)
            ) {
              isSelected = true;
              break;
            }
          }

          d[i] = {
            value: d[i].brandcategorycode,
            label: d[i].brandcategory,
            selected: isSelected,
          };
        }
      } else {
        for (let i = 0; i < d.length; i++) {
          d[i] = {
            value: d[i].brandcategorycode,
            label: d[i].brandcategory,
            selected: false,
          };
        }
      }

      utility.sortBy(d, "label");

      setCategoryListing(d);
    } else {
      toast.error("failed to fetch categories");
    }
  };

  const getBrands = async () => {
    let advID = advertiser.value;
    let ctID = contentType.value;

    if (!advID) {
      return;
    }

    let selectedCategories = categoryListing
      .filter(x => x.selected)
      .map(x => x.value);

    let catQuery = "";
    if (selectedCategories.length) {
      catQuery += "&c=" + selectedCategories.join("&c=");
    }

    let d = await dataProvider.network.post(`min-master/brand`, {
      content_type: parseInt(ctID),
      advertisers: [parseInt(advID)],
      categories: selectedCategories.map(x => parseInt(x)),
    });
    if (d) {
      const cloneSub = JSON.parse(localStorage.getItem(LS_CLONE_SUB_KEY));
      if (cloneSub) {
        for (let i = 0; i < d.length; i++) {
          let isSelected = false;
          for (let j = 0; j < cloneSub.brandList.length; j++) {
            if (parseInt(cloneSub.brandList[j].id) === parseInt(d[i].id)) {
              isSelected = true;
              break;
            }
          }
          d[i] = { value: d[i].id, label: d[i].name, selected: isSelected };
        }
      } else {
        d = d.map(x => {
          return { value: x.id, label: x.name, selected: false };
        });
      }

      utility.sortBy(d, "label");

      setBrandListing(d);
    } else {
      toast.error("failed to fetch min brands");
    }
  };

  const getDescriptors = async () => {
    let advID = advertiser.value;
    let ctID = contentType.value;
    let bcIDs = [];
    let bIDs = [];

    if (!advID) {
      return;
    }

    for (let i = 0; i < brandListing.length; i++) {
      if (brandListing[i].selected) {
        bIDs.push(brandListing[i].value);
      }
    }

    for (let i = 0; i < categoryListing.length; i++) {
      if (categoryListing[i].selected) {
        bcIDs.push(categoryListing[i].value);
      }
    }

    let url = `min-master/descriptor?content-type=${ctID}&advertiser=${advID}`;
    if (bIDs.length) {
      url += `&b=${bIDs.join("&b=")}`;
    }
    if (bcIDs.length) {
      url += `&bc=${bcIDs.join("&bc=")}`;
    }

    let d = await dataProvider.network.get(url);
    if (d) {
      const cloneSub = JSON.parse(localStorage.getItem(LS_CLONE_SUB_KEY));
      if (cloneSub) {
        for (let i = 0; i < d.length; i++) {
          let isSelected = false;
          for (let j = 0; j < cloneSub.captionList.length; j++) {
            if (parseInt(cloneSub.captionList[j].id) === parseInt(d[i].id)) {
              isSelected = true;
              break;
            }
          }
          d[i] = { value: d[i].id, label: d[i].name, selected: isSelected };
        }
      } else {
        d = d.map(x => {
          return { value: x.id, label: x.name, selected: false };
        });
      }

      utility.sortBy(d, "label");

      setCaptionListing(d);
    } else {
      toast.error("failed to fetch min descriptors");
    }
  };

  const getGroups = async () => {
    try {
      let d = await dataProvider.network.get("min-master/groups");
      d = d.map(x => {
        return { label: x.name, value: x.id };
      });

      utility.sortBy(d, "label");

      setGroups(d);

      // if clone then select the group
      const cloneSub = JSON.parse(localStorage.getItem(LS_CLONE_SUB_KEY));
      if (cloneSub) {
        for (let i = 0; i < d.length; i++) {
          if (parseInt(d[i].value) === parseInt(cloneSub.group.value)) {
            setGroup(d[i]);
            setPeriodFrom(cloneSub.periodFrom);
            setPeriodTo(cloneSub.periodTo);
            setContentType({
              value: cloneSub.contentType.value,
              label: CONTENT_TYPES[cloneSub.contentType.value],
            });
          }
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch groups");
    }
  };

  const getGroup = async groupID => {
    try {
      let d = await dataProvider.network.get("group?id=" + groupID);
      setGroupSubscriptionFrom(d.subscription_from);
      setGroupSubscriptionTo(d.subscription_to);
      setGroupDetails(d);
      console.log('db isc',d.is_ica);
 setIsIca(d.is_ica);
      // if clone then select the group
      const cloneSub = JSON.parse(localStorage.getItem(LS_CLONE_SUB_KEY));
      if (cloneSub) {
        setPeriodFrom(cloneSub.periodFrom);
        setPeriodTo(cloneSub.periodTo);
        setContentType({
          value: cloneSub.contentType.value,
          label: CONTENT_TYPES[cloneSub.contentType.value],
        });
      }

      ///content type
 // Example condition — modify as per your logic
  let filtered = Object.keys(CONTENT_TYPES)
    .filter(k => k !== "0")
    .map(k => ({
      value: k,
      label: CONTENT_TYPES[k],
    }));
  if (d.is_ica === false) {
    filtered = filtered.filter(opt => opt.value !== "105");
  }else{
     filtered =  filtered ;
  }

  setContentTypeOptions(filtered);
    } catch (error) {
      toast.error("Failed to fetch group details");
    }
  };
  const getChannels = async () => {
    let params = {
      language: [],
      genre: [],
      network: [],
    };

    // Handle multi-select arrays for language, genre, and network
    if (language && language.length > 0) {
      const selectedLanguages = language
        .filter(l => l && l.value)
        .map(l => l.value);
      if (selectedLanguages.length > 0) {
        params.language = selectedLanguages.join(",");
      }
    }

    if (genre && genre.length > 0) {
      const selectedGenres = genre.filter(g => g && g.value).map(g => g.value);
      if (selectedGenres.length > 0) {
        params.genre = selectedGenres.join(",");
      }
    }

    if (network && network.length > 0) {
      const selectedNetworks = network
        .filter(n => n && n.value)
        .map(n => n.value);
      if (selectedNetworks.length > 0) {
        params.network = selectedNetworks.join(",");
      }
    }

    // Construct query string
    let queryParams = Object.keys(params)
      .filter(key => params[key].length > 0)
      .map(key => key + "=" + params[key])
      .join("&");

    console.log("Final query string:", queryParams);

    try {
      let fetchedChannels = await dataProvider.network.get(
        `min-master/channels?${queryParams}`
      );

      if (fetchedChannels) {
        fetchedChannels = fetchedChannels.map(x => ({
          label: x.name,
          value: x.id,
        }));

        // Get previously selected channels from local storage (for clone/edit scenario)
        const cloneSub = JSON.parse(localStorage.getItem(LS_CLONE_SUB_KEY));
        let alreadySelectedChannels = [];
        if (cloneSub && cloneSub.channelsList) {
          alreadySelectedChannels = cloneSub.channelsList.map(sub => ({
            value: sub.id,
            label: sub.name,
          }));

          // Preserve selected channels even when filters are cleared
          const updatedSelectedChannels =
            alreadySelectedChannels.length > 0
              ? [...alreadySelectedChannels]
              : [];
          // Set channels while keeping the selected channels intact
          setChannelListing(fetchedChannels);
          // Combine the selected channels and fetched channels, avoiding duplicates
          const combinedChannels = [
            ...new Set([...updatedSelectedChannels, ...fetchedChannels]),
          ];
          // Ensure no duplicate channels in selected
          setSelectedChannels(updatedSelectedChannels);

          utility.sortBy(combinedChannels, "label");
        } else {
          // Preserve selected channels even when filters are cleared
          const updatedSelectedChannels =
            selectedChannels.length > 0 ? [...selectedChannels] : [];

          // Set channels while keeping the selected channels intact
          setChannelListing(fetchedChannels);

          // Combine the selected channels and fetched channels, avoiding duplicates
          const combinedChannels = [
            ...new Set([...updatedSelectedChannels, ...fetchedChannels]),
          ];

          // Ensure no duplicate channels in selected
          setSelectedChannels(updatedSelectedChannels);

          utility.sortBy(combinedChannels, "label");
        }
      } else {
        toast.error("Failed to fetch channels");
      }
    } catch (error) {
      console.error("Error fetching channels:", error);
      toast.error("Failed to fetch channels");
    }
  };

  const getClients = async () => {
    let d = await dataProvider.network.get(
      "min-master/clients?group-id=" + group.value
    );
    if (d) {
      d = d.map(x => {
        return { label: x.name, value: x.id, client_type: x.client_type };
      });

      utility.sortBy(d, "label");

      setClients(d);

      // if clone then select the client
      const cloneSub = JSON.parse(localStorage.getItem(LS_CLONE_SUB_KEY));
      if (cloneSub) {
        for (let i = 0; i < d.length; i++) {
          if (parseInt(d[i].value) === parseInt(cloneSub.client.value)) {
            setClient(d[i]);
          }
        }
      }




    } else {
      alert("failed to fetch clients");
    }
  };
useEffect(() => {
  if (!group) return;

  let options = Object.keys(CONTENT_TYPES)
    .filter(k => k !== "0")
    .map(k => ({
      value: k,
      label: CONTENT_TYPES[k],
    }));

  // 🔥 Example condition (modify as needed)
  //if (group === "1") {
  //  options = options.filter(opt => opt.value === "105");
  //}

  setContentTypeOptions(options);
  setContentType(null); // reset selection
}, [group]);
  const getApprovingAuthorities = async () => {
    try {
      let entries = await dataProvider.network.post(
        "min-master/approving-authority",
        { client_id: token.client_id }
      );
      entries = entries.map(x => ({ label: x.name, value: x.id }));
      setApprovingAuthorities(entries);
    } catch (error) {
      toast.error("failed to fetch approving authorities");
    }
  };

  const getAdvertisers = async () => {
    let d = await dataProvider.network.get(
      "min-master/group-advertisers?group-id=" + group.value
    );
    if (d) {
      d = d.map(x => {
        return { label: x.name, value: x.id };
      });

      utility.sortBy(d, "label");

      setAdvertisers(d);

      // if clone then select the advertiser
      const cloneSub = JSON.parse(localStorage.getItem(LS_CLONE_SUB_KEY));
      if (cloneSub) {
        for (let i = 0; i < d.length; i++) {
          for (let j = 0; j < cloneSub.advertiserList.length; j++) {
            if (
              parseInt(d[i].value) === parseInt(cloneSub.advertiserList[j].id)
            ) {
              setAdvertiser(d[i]);
            }
          }
        }
      }
    } else {
      alert("failed to fetch advertisers of group");
    }
  };

  const getClientInfo = async () => {
    try {
      let data = await dataProvider.network.get("client-info");

      setGroup({ label: data.group_name, value: data.group_id });
      setClient({ label: data.client_name, value: data.client_id });
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch client details");
    }
  };

  const getLanguages = async () => {
    try {
      let data = await dataProvider.network.get("masters/content-language");

      data = data.map(x => ({
        label: x.content_language,
        value: x.content_language_code,
      }));
      setLanguages([...data]);
      console.log("data of language", data);
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch languages");
    }
  };

  const getGenres = async () => {
    try {
      let data = await dataProvider.network.get("masters/genrecode");

      data = data.map(x => ({
        label: x.programGenre,
        value: x.programgenreCode,
      }));
      setGenres([...data]);
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch genres");
    }
  };

  const getNetworks = async () => {
    try {
      let data = await dataProvider.network.get("masters/network");

      data = data.map(x => ({
        label: x.networkname,
        value: x.networkcode,
      }));
      setNetworks([...data]);
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch networks");
    }
  };

  const setToggleDataForClone = async () => {
    const cloneSub = JSON.parse(localStorage.getItem(LS_CLONE_SUB_KEY));
    if (cloneSub) {
      let indexesToCall = [];
      // categories
      if (cloneSub.categoryList.length) {
        indexesToCall.push(0);
        getBrandCategories();
      }

      // brand
      if (cloneSub.brandList.length) {
        indexesToCall.push(1);
        getBrands();
      }

      // caption
      if (cloneSub.captionList.length) {
        indexesToCall.push(2);
        getDescriptors();
      }

      // edits
      if (cloneSub.edit.length) {
        indexesToCall.push(3);
        setSelectedEdits(cloneSub.edit);
      }

      // channels
      if (cloneSub.channelsList.length) {
        indexesToCall.push(4);
        getChannels();
      }

      if (indexesToCall.length) {
        let newState = [...allSelectedState];
        for (let i = 0; i < indexesToCall.length; i++) {
          newState[indexesToCall[i]] = false;
        }
        setAllSelectedState(newState);
      }
    }
  };

  const updateAllListItemSelectStatus = (listName, theStatus) => {
    let theList = [];
    console.log(listName, theStatus);
    if (listName === "categories") {
      theList = [...categoryListing];
    }
    if (listName === "brands") {
      theList = [...brandListing];
    }
    if (listName === "captions") {
      theList = [...captionListing];
    }
    if (listName === "edits") {
      theList = [...editListing];
    }
    if (listName === "channels") {
      theList = [...channelListing];
    }

    theList = theList.map(x => ({
      label: x.label,
      value: x.value,
      selected: theStatus,
    }));

    if (listName === "categories") {
      setCategoryListing(theList);
    }
    if (listName === "brands") {
      setBrandListing(theList);
    }
    if (listName === "captions") {
      setCaptionListing(theList);
    }
    if (listName === "edits") {
      setEditListing(theList);
    }
    if (listName === "channels") {
      setChannelListing(theList);
    }
  };

  const updateListItemStatus = (listName, value, theStatus) => {
    let theList = [];

    if (listName === "categories") {
      theList = [...categoryListing];
    }
    if (listName === "brands") {
      theList = [...brandListing];
    }
    if (listName === "captions") {
      theList = [...captionListing];
    }
    if (listName === "edits") {
      theList = [...editListing];
    }
    if (listName === "channels") {
      theList = [...channelListing];
    }

    for (let i = 0; i < theList.length; i++) {
      if (theList[i].value === value) {
        theList[i].selected = theStatus;
      }
    }

    if (listName === "categories") {
      setCategoryListing(theList);
    }
    if (listName === "brands") {
      setBrandListing(theList);
    }
    if (listName === "captions") {
      setCaptionListing(theList);
    }
    if (listName === "edits") {
      setEditListing(theList);
    }
    if (listName === "channels") {
      setChannelListing(theList);
    }
  };

  const listSearch = (item, searchKey, minKeywords = 2) => {
    if (searchKey.length >= minKeywords) {
      if (!item.label.toLowerCase().includes(searchKey)) {
        return false;
      }
    }

    return true;
  };
  // Filtering logic that keeps selected channels intact while filtering
  const filteredChannelListing = channelListing.filter(x =>
    listSearch(x, allSearches.channels.toLowerCase())
  ); // Apply your search filters

  const setSelectedEdits = selectedList => {
    let theList = [...editListing];
    for (let i = 0; i < theList.length; i++) {
      let isSelected = false;
      for (let j = 0; j < selectedList.length; j++) {
        if (parseInt(theList[i].value) === parseInt(selectedList[j].label)) {
          isSelected = true;
          break;
        }
      }
      theList[i].selected = isSelected;
    }

    setEditListing(theList);
  };

  const addSelectedChannel = channel => {
    if (!selectedChannels.some(c => c.value === channel.value)) {
      setSelectedChannels([...selectedChannels, channel]);
    }
  };
  const removeSelectedChannel = idx => {
    const newList = [...selectedChannels];
    newList.splice(idx, 1); // Remove the channel from the selected list
    setSelectedChannels(newList);
  };
  const channelInputModal = (
    <LargeModal onClose={_ => setShowInputModal(false)}>
      <div className="flex flex-v-center">
        <h3>Input Channels</h3>
        <span className="info">Select your channels wisely</span>
      </div>
      <div className="flex mtop channel-inputs">
        <div className="flex flex-col col col-raw-input">
          <div className="el">
            <h4>Raw Input</h4>
          </div>
          <div className="el">
            <textarea
              value={channelInput}
              onChange={e => setChannelInput(e.target.value)}
              placeholder="Newline seaparated channel list"
            ></textarea>
          </div>
          <div className="el">
            <button onClick={findChannels}>Find</button>
          </div>
        </div>
        <div className="flex flex-col col col-results">
          <div className="el flex flex-v-center">
            <h4>Results</h4>
            <div className="counts">
              <span>Total Input - {totalInputCount}</span>
              <span>
                Total Matched - {matchedList.filter(x => x.matched).length}
              </span>
            </div>
          </div>
          <div className="el channel-results flex flex-col">
            <div className="flex">
              <div className="flex-full result-item">
                <h4 className="bold" style={{ fontSize: "0.875rem" }}>
                  Input
                </h4>
              </div>
              <div className="flex-full result-item">
                <h4 className="bold" style={{ fontSize: "0.875rem" }}>
                  Matches
                </h4>
              </div>
            </div>
            {matchedList.map((mi, idx) => (
              <div className="flex" key={idx}>
                <div className="flex-full result-item">{mi.raw}</div>
                <div className="flex-full result-item">
                  {mi.matched ? (
                    mi.matched.label
                  ) : (
                    <Select
                      value={mi.matched}
                      options={channelListing.filter(x => !x.selected)}
                      placeholder="Select Channel"
                      onChange={e => handleNotFoundSelect(idx, e)}
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
          <div className="el">
            <button onClick={addMatchedListToSelected}>Add to selected</button>
          </div>
        </div>
      </div>
    </LargeModal>
  );

  const previewData = {
    group,
    client,
    group_type: groupDetails ? groupDetails.client_type : "",
    contentType: contentType,
    advertiser: advertiser,
    advertiserList: [{ id: advertiser.value, name: advertiser.label }],
    periodFrom,
    periodTo,
    approvingAuthority: approvingAuthority,
    category: allSelectedState[0]
      ? []
      : categoryListing.filter(x => x.selected),
    categoryList: allSelectedState[0]
      ? []
      : categoryListing
        .filter(x => x.selected)
        .map(x => ({ id: x.value, name: x.label })),
    brand: allSelectedState[1] ? [] : brandListing.filter(x => x.selected),
    brandList: allSelectedState[1]
      ? []
      : brandListing
        .filter(x => x.selected)
        .map(x => ({ id: x.value, name: x.label })),
    caption: allSelectedState[2] ? [] : captionListing.filter(x => x.selected),
    edit: allSelectedState[3] ? [] : editListing.filter(x => x.selected),
    channels: allSelectedState[4] ? [] : selectedChannels,
    user: token,
  };

  const previewModal = (
    <SubscriptionPreview
      onClose={() => setShowPreview(false)}
      data={previewData}
      showCreateAction={true}
    />
  );

  useEffect(() => {
    if (token.client_type) {
      getClientInfo();
    } else {
      getGroups();
    }

    getChannels();
    getLanguages();
    getGenres();
    getNetworks();

    return () => {
      localStorage.removeItem(LS_CLONE_SUB_KEY);
    };
  }, []);

  useEffect(() => {
    if (group.value) {
      if (!token.client_type) {
        getClients();
      }

      getAdvertisers();
      getGroup(group.value);
    }
  }, [group]);

  useEffect(() => {
    getApprovingAuthorities();
  }, [client.value]);

  useEffect(() => {
    setToggleDataForClone();
  }, [advertiser]);

  useEffect(() => {
    getChannels();
  }, [language, genre, network]);

  const previewHandler = () => {
    try {
      if (!group) {
        throw new Error("Please select a group");
      }
      if (!client) {
        throw new Error("Please select a client");
      }
      if (!periodFrom) {
        throw new Error("Please select the period from");
      }
      if (!periodTo) {
        throw new Error("Please select the period to");
      }
      if (!contentType) {
        throw new Error("Please select the content type");
      }

      // Handle advertiser validation based on permission
      if (!permissionCheck("disable_advertiser_select")) {
        if (!advertiser) {
          throw new Error("Please select an advertiser");
        }
      }

      // Approving authority validation
      if (token.client_id && !approvingAuthority) {
        throw new Error("Please select an approving authority");
      }
    } catch (error) {
      toast.error(error.message); // Use error.message to extract the error string
      return;
    }

    setShowPreview(true);
  };

  const handleClearToDate = () => {
    setPeriodTo(""); // Assuming `setPeriodTo` is the state updater function for the "to" date
  };
  // Custom label to show the count of selected languages
  const selectedLanguagesTemplate = selectedValues => {
    if (selectedValues.length === 0) {
      return <span>Select Language</span>;
    } else if (selectedValues.length === 1) {
      return (
        <span>{languages.find(l => l.value === selectedValues[0]).label}</span>
      );
    } else {
      return <span>{selectedValues.length} languages selected</span>;
    }
  };

  return (
    <section id="new-subscription">
      {showInputModal && channelInputModal}
      {showPreview && previewModal}

      <div className="flex">
        <div className="right">
          <button onClick={previewHandler}>Preview</button>
        </div>
      </div>
      <div className="pbox mtop" style={{ paddingBottom: "2rem" }}>
        <h3>Subscription Details</h3>
        <div className="flex mtop flex-v-center">
          <div className="flex flex-col" style={{ width: "60%" }}>
            {[USER_BUSINESS_ADMIN, USER_SUPERADMIN].includes(token.type) && (
              <div className="full-row flex flex-v-center">
                <div className="el full-row">
                  <Select
                    value={group}
                    onChange={val => {
                      setGroup(val);
                      setClient("");
                      setAdvertiser("");
                    }}
                    placeholder="Group"
                    options={groups}
                  />
                </div>
                <div className="el full-row">
                  <Select
                    value={client}
                    onChange={val => setClient(val)}
                    placeholder="Client"
                    options={clients}
                  />
                </div>
              </div>
            )}
            <div className="full-row flex flex-v-center">
              <div className="el full-row">
                <DateInput
                  value={periodFrom}
                  min={groupSubscriptionFrom}
                  max={groupSubscriptionTo}
                  onChange={val => setPeriodFrom(val)}
                  placeholder="Period from"
                />
              </div>
              <div className="el full-row">
                <DateInput
                  value={periodTo}
                  min={groupSubscriptionFrom}
                  max={groupSubscriptionTo}
                  fromDate={periodFrom}
                  toDate={periodTo}
                  onChange={val => setPeriodTo(val)}
                  onInvalidDate={() =>
                    alert("To date must be greater than from date")
                  }
                  onClearToDate={handleClearToDate}
                  placeholder="Period to"
                />
              </div>
            </div>
            <div className="full-row flex flex-v-center">
              <div className="el full-row">
                <Select
                  value={contentType}
                  onChange={val => setContentType(val)}
                  placeholder="Content Type"
                  options={contentTypeOptions}
                />
              </div>
              {token.client_type !== CLIENT_BROADCASTER && (
                <div className="el full-row">
                  {permissionCheck("show_advertiser_select") && (
                    <Select
                      isDisabled={permissionCheck("disable_advertiser_select")}
                      value={advertiser}
                      onChange={val => setAdvertiser(val)}
                      placeholder="Advertiser"
                      options={advertisers}
                    />
                  )}
                </div>
              )}
            </div>
            {![
              USER_SUPERADMIN,
              USER_BUSINESS_ADMIN,
              USER_CLIENT_MANAGER,
            ].includes(token.type) && (
                <div className="full-row flex flex-v-center">
                  <div className="el full-row">
                    <Select
                      value={approvingAuthority}
                      options={approvingAuthorities}
                      onChange={val => setApprovingAuthority(val)}
                      placeholder="Approving Authority"
                    />
                  </div>
                </div>
              )}
          </div>
          <div
            className="flex flex-col col pad-lr sub-toggles"
            style={{ width: "40%" }}
          >
            {token.client_type === CLIENT_BROADCASTER ? (
              <div className="el flex flex-center full-row">
                <>
                  <span>{selectItems[4]}</span>
                  <Toggle
                    disabled={!permissionCheck("enable_channel_toggle")}
                    options={["All", "Select"]}
                    onChange={val => handleAllSelected(4, val)}
                    defaultLeft={allSelectedState[4]}
                  />
                </>
              </div>
            ) : (
              selectItems.map((si, index) => (
                <div className="el flex flex-center full-row" key={index}>
                  {index === 4 ? (
                    <>
                      <span>{si}</span>
                      <Toggle
                        disabled={!permissionCheck("enable_channel_toggle")}
                        options={["All", "Select"]}
                        onChange={val => handleAllSelected(index, val)}
                        defaultLeft={allSelectedState[index]}
                      />
                    </>
                  ) : (
                    <>
                      <span>{si}</span>
                      <Toggle
                        disabled={!permissionCheck("enable_toggles")}
                        options={["All", "Select"]}
                        onChange={val => handleAllSelected(index, val)}
                        defaultLeft={allSelectedState[index]}
                      />
                    </>
                  )}
                </div>
              ))
            )}
          </div>
        </div>

        {/* categories */}

        {!allSelectedState[0] && (
          <div
            className="mtop item-selector-wrapper flash-highlight"
            ref={selRefs[0]}
          >
            <div className="flex full-row flex-v-center flex-h-between item-selector-categories">
              <div className="el">
                <h4>Select Categories</h4>
              </div>
              <div className="el" style={{ flex: 1 }}>
                <input
                  type="text"
                  placeholder="Search"
                  value={allSearches.categories}
                  onChange={e =>
                    setAllSearches({
                      ...allSearches,
                      categories: e.target.value,
                    })
                  }
                />
              </div>
            </div>
            <div className="flex mtop item-selector">
              <div className="flex flex-col col flex-full">
                <div className="el flex flex-v-center">
                  <div className="item-label bold">All</div>
                  <div className="item-action">
                    <IconButton
                      icon="add"
                      onClick={() =>
                        updateAllListItemSelectStatus("categories", true)
                      }
                    />
                  </div>
                </div>
                {categoryListing
                  .filter(x => !x.selected)
                  .filter(x =>
                    listSearch(x, allSearches.categories.toLowerCase())
                  )
                  .map((cat, idx) => (
                    <div
                      className="el flex flex-v-center item-row"
                      key={idx}
                      onClick={() =>
                        updateListItemStatus("categories", cat.value, true)
                      }
                    >
                      <div className="item-label">{cat.label}</div>
                      <div className="item-action">
                        <IconButton icon="add" />
                      </div>
                    </div>
                  ))}
              </div>
              <div className="flex flex-col col flex-full">
                <div className="el flex flex-v-center">
                  <div className="item-label bold">Selected</div>
                  <div className="item-action">
                    <IconButton
                      icon="remove"
                      onClick={() =>
                        updateAllListItemSelectStatus("categories", false)
                      }
                    />
                  </div>
                </div>
                {categoryListing
                  .filter(x => x.selected)
                  .filter(x =>
                    listSearch(x, allSearches.categories.toLowerCase())
                  )
                  .map((cat, idx) => (
                    <div
                      className="el flex flex-v-center item-row"
                      key={idx}
                      onClick={() =>
                        updateListItemStatus("categories", cat.value, false)
                      }
                    >
                      <div className="item-label">{cat.label}</div>
                      <div className="item-action">
                        <IconButton icon="remove" />
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        )}

        {/* categories end */}

        {/* brands */}
        {!allSelectedState[1] && (
          <div
            className="mtop item-selector-wrapper flash-highlight"
            ref={selRefs[1]}
          >
            <div className="flex full-row flex-v-center flex-h-between item-selector-brands">
              <div className="el">
                <h4>Select Brands</h4>
              </div>
              <div className="el" style={{ flex: 1 }}>
                <input
                  type="text"
                  placeholder="Search"
                  value={allSearches.brands}
                  onChange={e =>
                    setAllSearches({ ...allSearches, brands: e.target.value })
                  }
                />
              </div>
            </div>
            <div className="flex mtop item-selector">
              <div className="flex flex-col col flex-full">
                <div className="el flex flex-v-center">
                  <div className="item-label bold">All</div>
                  <div className="item-action">
                    <IconButton
                      icon="add"
                      onClick={() =>
                        updateAllListItemSelectStatus("brands", true)
                      }
                    />
                  </div>
                </div>
                {brandListing
                  .filter(x => !x.selected)
                  .filter(x => listSearch(x, allSearches.brands.toLowerCase()))
                  .map((item, idx) => (
                    <div
                      className="el flex flex-v-center item-row"
                      key={idx}
                      onClick={() =>
                        updateListItemStatus("brands", item.value, true)
                      }
                    >
                      <div className="item-label">{item.label}</div>
                      <div className="item-action">
                        <IconButton icon="add" />
                      </div>
                    </div>
                  ))}
              </div>
              <div className="flex flex-col col flex-full">
                <div className="el flex flex-v-center">
                  <div className="item-label bold">Selected</div>
                  <div className="item-action">
                    <IconButton
                      icon="remove"
                      onClick={() =>
                        updateAllListItemSelectStatus("brands", false)
                      }
                    />
                  </div>
                </div>
                {brandListing
                  .filter(x => x.selected)
                  .filter(x => listSearch(x, allSearches.brands.toLowerCase()))
                  .map((item, idx) => (
                    <div
                      className="el flex flex-v-center item-row"
                      key={idx}
                      onClick={() =>
                        updateListItemStatus("brands", item.value, false)
                      }
                    >
                      <div className="item-label">{item.label}</div>
                      <div className="item-action">
                        <IconButton icon="remove" />
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        )}

        {/* brands end */}

        {/* captions */}

        {!allSelectedState[2] && (
          <div
            className="mtop item-selector-wrapper flash-highlight"
            ref={selRefs[2]}
          >
            <div className="flex full-row flex-v-center flex-h-between item-selector-captions">
              <div className="el">
                <h4>Select Captions</h4>
              </div>
              <div className="el" style={{ flex: 1 }}>
                <input
                  type="text"
                  placeholder="Search"
                  value={allSearches.captions}
                  onChange={e =>
                    setAllSearches({ ...allSearches, captions: e.target.value })
                  }
                />
              </div>
            </div>
            <div className="flex mtop item-selector">
              <div className="flex flex-col col flex-full">
                <div className="el flex flex-v-center">
                  <div className="item-label bold">All</div>
                  <div className="item-action">
                    <IconButton
                      icon="add"
                      onClick={() =>
                        updateAllListItemSelectStatus("captions", true)
                      }
                    />
                  </div>
                </div>
                {captionListing
                  .filter(x => !x.selected)
                  .filter(x =>
                    listSearch(x, allSearches.captions.toLowerCase())
                  )
                  .map((item, idx) => (
                    <div
                      className="el flex flex-v-center item-row"
                      key={idx}
                      onClick={() =>
                        updateListItemStatus("captions", item.value, true)
                      }
                    >
                      <div className="item-label">{item.label}</div>
                      <div className="item-action">
                        <IconButton icon="add" />
                      </div>
                    </div>
                  ))}
              </div>
              <div className="flex flex-col col flex-full">
                <div className="el flex flex-v-center">
                  <div className="item-label bold">Selected</div>
                  <div className="item-action">
                    <IconButton
                      icon="remove"
                      onClick={() =>
                        updateAllListItemSelectStatus("captions", false)
                      }
                    />
                  </div>
                </div>
                {captionListing
                  .filter(x => x.selected)
                  .filter(x =>
                    listSearch(x, allSearches.captions.toLowerCase())
                  )
                  .map((item, idx) => (
                    <div
                      className="el flex flex-v-center item-row"
                      key={idx}
                      onClick={() =>
                        updateListItemStatus("captions", item.value, false)
                      }
                    >
                      <div className="item-label">{item.label}</div>
                      <div className="item-action">
                        <IconButton icon="remove" />
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        )}

        {/* captions end */}

        {/* edits */}

        {!allSelectedState[3] && (
          <div
            className="mtop item-selector-wrapper flash-highlight"
            ref={selRefs[3]}
          >
            <div className="flex full-row flex-v-center flex-h-between item-selector-edits">
              <div className="el">
                <h4>Select Edits</h4>
              </div>
              <div className="el" style={{ flex: 1 }}>
                <input
                  type="text"
                  placeholder="Search"
                  value={allSearches.edits}
                  onChange={e =>
                    setAllSearches({ ...allSearches, edits: e.target.value })
                  }
                />
              </div>
            </div>
            <div className="flex mtop item-selector">
              <div className="flex flex-col col flex-full">
                <div className="el flex flex-v-center">
                  <div className="item-label bold">All</div>
                  <div className="item-action">
                    <IconButton
                      icon="add"
                      onClick={() =>
                        updateAllListItemSelectStatus("edits", true)
                      }
                    />
                  </div>
                </div>
                {editListing
                  .filter(x => !x.selected)
                  .filter(x => listSearch(x, allSearches.edits.toLowerCase()))
                  .map((item, idx) => (
                    <div
                      className="el flex flex-v-center item-row"
                      key={idx}
                      onClick={() =>
                        updateListItemStatus("edits", item.value, true)
                      }
                    >
                      <div className="item-label">{item.label}</div>
                      <div className="item-action">
                        <IconButton icon="add" />
                      </div>
                    </div>
                  ))}
              </div>
              <div className="flex flex-col col flex-full">
                <div className="el flex flex-v-center">
                  <div className="item-label bold">Selected</div>
                  <div className="item-action">
                    <IconButton
                      icon="remove"
                      onClick={() =>
                        updateAllListItemSelectStatus("edits", false)
                      }
                    />
                  </div>
                </div>
                {editListing
                  .filter(x => x.selected)
                  .filter(x => listSearch(x, allSearches.edits.toLowerCase()))
                  .map((item, idx) => (
                    <div
                      className="el flex flex-v-center item-row"
                      key={idx}
                      onClick={() =>
                        updateListItemStatus("edits", item.value, false)
                      }
                    >
                      <div className="item-label">{item.label}</div>
                      <div className="item-action">
                        <IconButton icon="remove" />
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        )}

        {/* edits end */}

        {/* channels */}

        {!allSelectedState[4] && (
          <div
            className="mtop item-selector-wrapper flash-highlight"
            ref={selRefs[4]}
          >
            <div className="flex full-row flex-v-center flex-h-between item-selector-channel">
              <div className="el">
                <h4>Select Channels</h4>
              </div>
              <div className="el">
                <input
                  type="text"
                  placeholder="Search"
                  value={allSearches.channels}
                  onChange={e =>
                    setAllSearches({ ...allSearches, channels: e.target.value })
                  }
                />
              </div>

              <div className="el">
                <MultiSelectDropdown
                  options={languages}
                  selectedValues={language}
                  setSelectedValues={setLanguage}
                  placeholder="Languages"
                />
              </div>

              <div className="el">
                <MultiSelectDropdown
                  options={genres}
                  selectedValues={genre}
                  setSelectedValues={setGenre}
                  placeholder="Genres"
                />
              </div>

              <div className="el">
                <MultiSelectDropdown
                  options={networks}
                  selectedValues={network}
                  setSelectedValues={setNetwork}
                  placeholder="Networks"
                />
              </div>
              <div className="el">
                <button
                  className="grey-button"
                  onClick={() => setShowInputModal(true)}
                  style={{ height: "32px", padding: "0 0.5rem" }}
                >
                  Paste channels
                </button>
              </div>
            </div>
            <div className="flex mtop item-selector">
              <div className="flex flex-col col flex-full">
                <div className="el flex flex-v-center">
                  <div className="item-label bold">All Channels</div>
                  <div className="item-action">
                    <IconButton
                      icon="add"
                      onClick={() =>
                        setSelectedChannels([
                          ...selectedChannels,
                          ...filteredChannelListing.filter(
                            x =>
                              !selectedChannels.some(c => c.value === x.value) // Add only channels not already selected
                          ),
                        ])
                      }
                    />
                  </div>
                </div>
                {/* Display Filtered Channels */}
                {filteredChannelListing.map((cat, idx) => (
                  <div
                    className="el flex flex-v-center item-row"
                    key={idx}
                    onClick={() => addSelectedChannel(cat)} // Add selected channel
                  >
                    <div className="item-label">{cat.label}</div>
                    <div className="item-action">
                      <IconButton icon="add" />
                    </div>
                  </div>
                ))}
              </div>
              <div className="flex flex-col col flex-full">
                {/* Selected Channels List */}
                <div className="el flex flex-v-center">
                  <div className="item-label bold">Selected Channels</div>
                  <div className="item-action">
                    <IconButton
                      icon="remove"
                      onClick={() => setSelectedChannels([])}
                    />
                  </div>
                </div>
                {/* Display Selected Channels */}
                {selectedChannels.map((cat, idx) => (
                  <div
                    className="el flex flex-v-center item-row"
                    key={idx}
                    onClick={() => removeSelectedChannel(idx)} // Remove selected channel manually
                  >
                    <div className="item-label">{cat.label}</div>
                    <div className="item-action">
                      <IconButton icon="remove" />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default NewSubscription;
